import { defineStore } from 'pinia'
import { ref } from 'vue'

interface IArea {
  id: string
  name: string
  logo: string
}

interface IBaseInfo {
  currentArea: IArea
}
interface ISort {
  sort_field: number
  sort_mode: number
}

export const useBaseInfoStore = defineStore(
  'baseInfo',
  () => {
    const currentArea = ref<IArea>({
      id: '',
      name: '',
      logo: '',
    })

    const setCurrentArea = (area: IArea) => {
      currentArea.value = area
    }
    const currentSort = ref<ISort>({
      sort_field: undefined,
      sort_mode: undefined,
    })
    const setCurrentSort = (sort: ISort) => {
      currentSort.value = sort
    }
    return {
      currentArea,
      setCurrentArea,
      currentSort,
      setCurrentSort,
    }
  },
  {
    persist: true,
  },
)
